import React from "react"

import SmallButton from "../../../toolkits/SmallButton/SmallButton"
import CustomPopup from "../../../toolkits/CustomPopup/CustomPopup"

import {SUCCESS_CODE, ERROR_CODE} from "../../../constants/other"
import {useDeactivateCouponMutation} from "../../../api/coupons"
import {useTranslation} from "react-i18next"


const DeleteCouponPopup = ({coupon, setUserMessage, refreshTable, close}) => {
    const { t } = useTranslation("common")

    const [deactivateCoupon, {isLoading}] = useDeactivateCouponMutation()

    const handleSubmit = () => {

        deactivateCoupon(coupon.id)
            .unwrap()
            .then(() => {
                refreshTable()
                setUserMessage({message: t("Coupon {{coupon}} was successfully deactivated!", {coupon: coupon.code}), code: SUCCESS_CODE})
            })
            .catch(error => {
                setUserMessage({message: error.message, code: ERROR_CODE})
            })
    }

    return (
        <CustomPopup text_title={t("Do you want to deactivate the {{coupon}} coupon?", {coupon: coupon.code})} isSubtitle isAgreePopup>
            <div className="popup-bottom">
                <div className="popup-bottom-button-container">
                    <SmallButton disabled={isLoading} btnType="secondary" onClick={close}> {t("Cancel").toUpperCase()} </SmallButton>
                    <SmallButton loading={isLoading} onClick={handleSubmit}> {t("Deactivate").toUpperCase()} </SmallButton>
                </div>
            </div>
        </CustomPopup>
    )
}

export default DeleteCouponPopup
